import React, { useState, useEffect } from "react";
import "./Financials.css";
import * as FeatherIcon from "react-feather";
import MicroChart from "../../../HtmlElements/MicroChart";

export default function BalanceSheet({ records = [], requiredValue }) {
  if (!records || Object.keys(records).length === 0) {
    //  return <div></div>;
  }

  const balance_sheet = {
    IQ_CASH_EQUIV: "Cash and Equivalents",
    IQ_TRADING_ASSETS: "Trading Asset Securities",
    IQ_CASH_ST_INVEST: "Total Cash And Short Term Investments",
    IQ_AR: "Accounts Receivable",
    IQ_TOTAL_RECEIV: "Total Receivables",
    IQ_INVENTORY: "Inventory",
    IQ_PREPAID_EXP: "Prepaid Exp.",
    IQ_DEF_TAX_ASSETS_CURRENT: "Deferred Tax Assets, Curr.",
    IQ_OTHER_CA_SUPPL: "Other Current Assets",
    IQ_TOTAL_CA: "Total Current Assets",
    IQ_GPPE: "Gross Property, Plant & Equipment",
    IQ_AD: "Accumulated Depreciation",
    IQ_NPPE: "Net Property, Plant & Equipment",
    IQ_LT_INVEST: "Long-Term Investments",
    IQ_GW: "Goodwill",
    IQ_DEF_TAX_ASSETS_LT: "Deferred Tax Assets, LT",
    IQ_OTHER_LT_ASSETS: "Other Long-Term Assets",
    IQ_TOTAL_ASSETS: "Total Assets",
    IQ_AP: "Accounts Payable",
    IQ_AE: "Accrued Exp.",
    IQ_ST_DEBT: "Short-Term Borrowings",
    IQ_CURRENT_PORT_DEBT: "Curr. Port. of LT Debt",
    IQ_CURRENT_PORT_LEASES: "Curr. Port. Of Cap. Leases",
    IQ_INC_TAX_PAY_CURRENT: "Curr. Income Taxes Payable",
    IQ_OTHER_CL: "Other Current Liabilities",
    IQ_TOTAL_CL: "Total Current Liabilities",
    IQ_LT_DEBT: "Long-Term Debt",
    IQ_CAPITAL_LEASES: "Capital Leases",
    IQ_PENSION: "Pension & Other Post-Retire Benefits",
    IQ_DEF_TAX_LIAB_LT: "Def. Tax Liability, Non. Current",
    IQ_OTHER_LIAB_LT: "Other Non-Current Liabilities",
    IQ_TOTAL_LIAB: "Total Liabilities",
    IQ_COMMON: "Common Stock",
    IQ_APIC: "Additional Paid in Capital",
    IQ_RE: "Retained Earnings",
    IQ_TREASURY: "Treasury Stock",
    IQ_OTHER_EQUITY: "Comprehensive Inc. and Other",
    IQ_TOTAL_COMMON_EQUITY: "Total Common Equity",
    IQ_MINORITY_INTEREST: "Minority Interest ",
    IQ_TOTAL_EQUITY: "Total Equity",
    IQ_TOTAL_LIAB_EQUITY: "Total Liabilities And Equity",
    IQ_TOTAL_OUTSTANDING_FILING_DATE: "Total Shares Out. On Filing Date",
    IQ_TOTAL_OUTSTANDING_BS_DATE: "Total Shares Out. On Balance Sheet Date",
    IQ_BV_SHARE: "Book/Value Share",
    IQ_TBV: "Tangible Book Value",
    IQ_TBV_SHARE: "Tangible Book Value/Share",
    IQ_TOTAL_DEBT: "Total Debt",
    IQ_NET_DEBT: "Net Debt",
    IQ_DEBT_EQUIV_OPER_LEASE: "Debt Equivalent Oper. Leases",
    IQ_MINORITY_INTEREST_TOTAL: "Total Minority Interest",
    IQ_INV_METHOD: "Inventory Method",
    IQ_LAND: "Land",
    IQ_BUILDINGS: "Buildings",
    IQ_MACHINERY: "Machinery",
    IQ_CIP: "Construction in Progress",
    IQ_FULL_TIME: "Full Time Employees",
    IQ_ASSETS_CAP_LEASE_GROSS: "Assets Under Cap. Lease, Gross",
    IQ_ASSETS_CAP_LEASE_DEPR: "Assets Under Cap. Lease, Accum. Depr.",
    IQ_ALLOW_DOUBT_ACCT: "Accum. Allowance for Doubtful Accts",
    IQ_FILINGDATE_BS: "Filing Date",
    // "IQ_RESTATEMENT_BS" : "Restatment Type",
    // "IQ_CALC_TYPE_BS" : "Calculation Type"
  };

  const recordsArray = Array.isArray(records) ? records : [];
  const latestYears = Array.from(
    new Set(
      recordsArray.flatMap((record) => record.data.map((item) => item.year))
    )
  )
    .sort((a, b) => b - a)
    .slice(0, 5)
    .reverse();

  // NEW: Filter out year columns where every displayed row value is n.a. or 0
  const isValueEmpty = (value) =>
    value === "" || value === "Data Unavailable" || value === 0 || value === undefined || value === null;
  const visibleYears = latestYears.filter(year => {
    const fieldKeys = new Set(Object.keys(balance_sheet));
    const relevantRecords = recordsArray.filter(r => fieldKeys.has(r._id));
    return relevantRecords.some(record => {
      const item = record.data.find(d => d.year === year);
      return item !== undefined && !isValueEmpty(item.value);
    });
  });
  // OLD: const yearsToRender = latestYears;
  const yearsToRender = visibleYears;

  return (
    <>
      {
        <div className="col-md-12 mb-2 mt-2">
          <div className="custom_card_block">
            <div className="quarterly_result_block">
              <div className="head_top">
                <h5 className="main_head">Balance Sheet</h5>
                <p className="main_head_para">
                  Consolidated Figures in $Mn
                  {/* / <span className='blue_text'>View Standalone</span> */}
                </p>
              </div>
              <div className="quater_table_block">
                {latestYears.length <= 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="alert alert-warning" role="alert">
                        Complete financials are only available in paid version.
                      </div>
                    </div>
                  </div>
                )}

                {latestYears.length > 0 && (
                  <div className="table-responsive custom_table_qut">
                    <table className="quater_table custom-resizable-table">
                      <thead className="quater_table_thead">
                        <tr className="quater_table_tr custom-resizable-table-header">
                          <th className="quater_table_th"></th>
                          {/* OLD: {latestYears.map((year) => ( <th> ))} */}
                          {yearsToRender.map((year) => (
                            <th key={year} className="quater_table_th">
                             <div className="custom-resizable-table-th-content"> {year}</div>
                            </th>
                          ))}
                          <th
                            className="quater_table_th text-center"
                            style={{ width: "110px" }}
                          >
                            <div className="custom-resizable-table-th-content">5-Year Trend</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="quater_table_tbody">
                        {Object.entries(balance_sheet).map(([key, label]) => {
                          const record = records.find(
                            (item) => item._id === key
                          );
                          if (!record) return null;

                          const yearDataMap = Object.fromEntries(
                            record.data.map((item) => [item.year, item.value])
                          );
                          // OLD: const chartData = latestYears.map((year) => ({ category: year, value: parseFloat(yearDataMap[year] || 0) }));
                          const chartData = yearsToRender.map((year) => ({
                            category: year,
                            value: parseFloat(yearDataMap[year] || 0),
                          }));

                          return (
                            <tr className="quater_table_tr dimension-row cursor-pointer gtr-row" key={key}>
                              <td className="quater_table_td_left gtr-cell"><div className="gtr-cell-content-container">{label}</div></td>
                              {/* OLD: {latestYears.map((year) => ( <td> ))} */}
                              {yearsToRender.map((year) => (
                                <td key={year} className="quater_table_td gtr-cell">
                                  <div className="gtr-cell-content-container">
                                  {yearDataMap[year] < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(yearDataMap[year])}
                                    </span>
                                  ) : (
                                    requiredValue(yearDataMap[year])
                                  )}
                                  </div>
                                </td>
                              ))}
                              <td className="quater_table_td text-center gtr-cell">
                                <MicroChart data={chartData} chartType="bar" />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}
